<!-- =========================================================================================
  File Name: DocumentTypeEdit.vue
  Description: DocumentType Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Tipo de documento de inventario no encontrada" :active.sync="id_not_found">
      <span>Datos de tipo de documento de inventario con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'document_types'}" class="text-inherit underline"> todos los tipo de documento de inventarios</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código" v-model="data_local.code" :enabled="editing && id == 0"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Descripción de la tipo de documento" v-model="data_local.name" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Función" highlight=true :dataSource="functions" :fields="{text: 'value', value: 'code'}" v-model="data_local.functionId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="w-full">
                <ejs-textbox name="comments" :multiline="true" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :enabled="editing"/>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        functions: [],
        data: null,
        data_local: {
          id: 0,
          code: '',
          name: '',
          comments: '',
          functionId: 'IN',
          functionName: ''
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'document_types'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/infra/document_types/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.code || this.data_local.code == '') {
          message = 'Debe especificar un código';
        } else if (!this.data_local.name || this.data_local.name == '') {
          message = 'Debe especificar un nombre';
        } else if (!this.data_local.functionId || this.data_local.functionId == '') {
          message = 'Debe seleccionar una función';
        } else {
          var functionId = this.functions.filter(item => item.code == this.data_local.functionId);
          if (functionId.length <= 0) {
            message = 'Función incorrecta';
          }
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: 'Función incorrecta',
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de tipo de documento de inventario',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/infra/document_types/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos del tipo de documento de inventario fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'document_type', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar tipo de documento de inventario "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando tipo de documento de inventario',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/infra/document_types/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Tipo de documento de inventario fue eliminado correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'documentTypes'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando tipo de documento de inventario',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'FUNCIONTIPODOCUMENTO'})
        .then(response => {
          if (response.data.success) {
            self.functions = response.data.data;
          }
          self.getData(this.id);
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
